import { useTranslations } from 'next-intl';

import type { ApiResponseError } from '@/lib/api';

import FetchBaseQueryAlert, { type FetchBaseQueryAlertProps } from './FetchBaseQueryAlert';

const ApiResponseErrorDisplay = ({ title, error, children }: FetchBaseQueryAlertProps) => {
	const t = useTranslations();

	// biome-ignore lint/style/noNonNullAssertion: error is non-null when this component is rendered (RTK Query guarantees it)
	if (Object.hasOwn(error!, 'status')) {
		const {
			status,
			data: { message },
		} = error as ApiResponseError;
		if (status === 404) {
			return (
				<div style={{ margin: '20px' }}>
					{title && <h3>{title}</h3>}
					<p>{message === 'Postcode not found' ? t('Generic.no-data') : message}</p>
					{children}
				</div>
			);
		}

		if (status === 423) {
			return (
				<div style={{ margin: '20px' }}>
					{title && <h3>{title}</h3>}
					<p>{message}.</p>
					{children}
				</div>
			);
		}
	}

	return error && <FetchBaseQueryAlert title={t('Generic.an-error-occurred')} error={error} />;
};
export default ApiResponseErrorDisplay;
